export enum SituacaoContaEnum {
  Ativa = '0',
  Inativa = '1',
  Bloqueada = '2'
}
